module.exports = __webpack_public_path__ + "static/media/July_2026_3.eab966fa.webp";